import { CheckboxField } from '@cian/components';
import * as React from 'react';
import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../common/state/app_state';
import { getTermValue } from '../../../../json_query/reducers/helpers';
import { changeHasVideo } from '../../../state/video';
import { InlineParam, Row } from '../markup';

interface IProps {
  value: boolean;
  onChange(value: boolean): void;
}

class Video extends React.PureComponent<IProps> {
  public render() {
    const { onChange, value } = this.props;

    return (
      <Row title="Видео">
        <InlineParam>
          <CheckboxField label="Только с видео" value={value} onValueChange={onChange} />
        </InlineParam>
      </Row>
    );
  }
}

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    value: Boolean(getTermValue('has_video')(state.filters.jsonQuery)),
  }),
  (dispatch: Dispatch) => ({
    onChange: (value: boolean) => dispatch(changeHasVideo(value)),
  }),
)(Video);
